<img *ngIf="isVisible" src="/assets/spinner.gif" class="spinner" />
